<template>
  <v-container fluid>
    <!-- <v-card style="margin-bottom: 20px;">
      <v-card-title>Applications</v-card-title>
      <v-card-text>
        <p>
          Applications are White Labeled applications running on the system.
        </p>
        <p>An Example of an Application is CritterPic</p>
      </v-card-text>
    </v-card>-->
    <v-card :loading="usersLoading">
      <v-toolbar color="primary" dark>
        User Management
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchUsers"
          label="Search"
          single-line
          hide-details
          prepend-icon="mdi-magnify"
          clearable
          v-on:input="onQuickFilterChanged()"
        ></v-text-field>
      </v-toolbar>
      <expandedToolbar :newButton="true" @newButtonClick="newUserDialog = true" />
      <v-card-text v-if="users">
        <v-row>
          <v-col style="height: calc(100vh - 230px) !important;" cols="12">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              rowSelection="multiple"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
            ></ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="manageUserDialog" persistent max-width="600px">
      <v-card v-if="users" tile>
        <v-toolbar color="primary" dark>
          Manage User
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            icon
            dark
            @click="
              manageUserDialog = false;
              userFormData = {};
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="userFormData.name" label="User Full Name"></v-text-field>
              </v-col>
              <v-col style="text-align: center" cols="4">
                <v-btn color="primary btnMargin">Password Reset</v-btn>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="applicationsAdminOf"
                  :items="applications"
                  item-text="name"
                  label="Applications Admin Of"
                  multiple
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item.id)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      <v-avatar class="accent white--text" left v-text="data.item.prefix"></v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="organizationsAdminOf"
                  :items="organizations"
                  item-text="name"
                  item-value="id"
                  label="Organizations Admin Of"
                  multiple
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item.id)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      <v-avatar
                        class="accent white--text"
                        left
                        v-text="data.item.application_prefix"
                      ></v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="organizationsUserOf"
                  :items="organizations"
                  item-text="name"
                  item-value="id"
                  label="Organizations User Of"
                  multiple
                  chips
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :key="JSON.stringify(data.item.id)"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      :disabled="data.disabled"
                      @click:close="data.parent.selectItem(data.item)"
                    >
                      <v-avatar
                        class="accent white--text"
                        left
                        v-text="data.item.application_prefix"
                      ></v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="manageUserLoading" @click="saveUser()" color="success">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newUserDialog" persistent max-width="600px">
      <v-card v-if="users" tile>
        <v-toolbar color="primary" dark>
          New User
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newUserDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="userFormData.email" label="User Email Address"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="userFormData.name" label="User Full Name"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="newUserLoading" @click="generateNewUser()" color="success">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="aGGridActionMenu" persistent max-width="300px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Action Menu
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="updateAGGridActionMenu()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-list dense>
                  <!-- <v-list-item :to="'/dashboard'">
                    <v-list-item-action>
                      <v-icon>mdi-account-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Event Profile</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>-->
                  <v-list-item @click="openManageUser()">
                    <v-list-item-action>
                      <v-icon>mdi-cogs</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Manage User</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import agGridActionButton from "@/components/agGridActionButton";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import { AgGridVue } from "ag-grid-vue";
  import moment from "moment";

  export default {
    components: { AppBar, AgGridVue, agGridActionButton, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "aGGridActionMenu",
        "selectedRowData",
        "users",
        "usersLoading",
        "applications",
        "applicationsLoading",
        "organizations",
        "organizationsLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      // AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "100%",

      drawer: null,
      usersHeaders: [
        {
          text: "ID",
          align: "left",
          sortable: true,

          value: "id",
          width: "80px",
        },
        { text: "Prefix", value: "prefix", width: "100px" },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Devices",
          value: "devices",
        },
        {
          text: "Organizations",
          value: "organizations",
        },
        {
          text: "Active Deployments",
          value: "deployments",
        },
        {
          text: "Created At",
          value: "created_at",
        },
        {
          text: "Updated At",
          value: "updated_at",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      searchUsers: "",
      //New Applications
      newUserDialog: false,
      newUserLoading: false,
      //Manage Applications
      manageUserDialog: false,
      manageUserLoading: false,
      //ApplicationFormData
      userFormData: {},

      organizationsUserOf: [],
      organizationsAdminOf: [],
      applicationsAdminOf: [],
    }),
    beforeMount() {
      this.columnDefs = [
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "agGridActionButton",
        },
        {
          headerName: "ID",
          field: "id",
        },
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "Email",
          field: "email",
        },
        {
          headerName: "Orgs Admin Of",
          field: "organizationsAdminOf",
        },
        {
          headerName: "Orgs user Of",
          field: "organizationsUserOf",
        },
      ];
      if (this.currentUserData.role === "superAdmin") {
        this.columnDefs.push({
          headerName: "Applications Admin Of",
          field: "applicationsAdminOf",
        });
      }
      console.log(this.currentUserData);
      this.$store.dispatch("loadUsers").then(() => {
        this.rowData = this.users;
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      });
      if (this.aGGridActionMenu == true) {
        this.$store.dispatch("setAGGridActionMenuState", {});
      }
    },
    mounted() {
      this.$store.dispatch("loadApplications");
      this.$store.dispatch("loadOrganizations");
    },
    watch: {
      users: function (oldApp, newApp) {
        this.rowData = this.users;
      },
    },
    methods: {
      onQuickFilterChanged() {
        this.gridApi.setQuickFilter(this.searchUsers);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
      },
      autoSizeColumnsAGGRID() {
        // this.gridApi.sizeColumnsToFit();
        var allColumnIds = [];
        this.columnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.columnApi.autoSizeColumns(allColumnIds, false);
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("setAGGridActionMenuState", cell.data);
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("setAGGridActionMenuState", {});
      },
      generateNewUser() {
        this.newUserLoading = true;
        this.$store.dispatch("newUser", this.userFormData).then((result) => {
          this.newUserLoading = false;
          if (result === "Success") {
            this.newUserDialog = false;
            this.$swal({
              title: "Success!",
              text: `${this.userFormData.name}'s account has been created. An email with their login details has been sent.`,
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error",
              text: `${this.userFormData.name} Could not be Created`,
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      openManageUser() {
        this.userFormData = this.selectedRowData;
        this.loadOrgUserOfData();
        this.loadOrgAdminOfData();
        this.loadAppAdminOfData();
        this.updateAGGridActionMenu();
        this.manageUserDialog = true;
      },
      loadOrgUserOfData() {
        let orgIDArray = this.userFormData.organizationsUserOf
          ? this.userFormData.organizationsUserOf.split(",")
          : [];
        let orgArray = this.organizations.filter((o) =>
          orgIDArray.includes(o.id)
        );
        this.organizationsUserOf = orgArray;
      },
      loadOrgAdminOfData() {
        let orgIDArray = this.userFormData.organizationsAdminOf
          ? this.userFormData.organizationsAdminOf.split(",")
          : [];
        let orgArray = this.organizations.filter((o) =>
          orgIDArray.includes(o.id)
        );
        this.organizationsAdminOf = orgArray;
      },
      loadAppAdminOfData() {
        let appIDArray = this.userFormData.applicationsAdminOf
          ? this.userFormData.applicationsAdminOf.split(",")
          : [];
        let appArray = this.applications.filter((a) => appIDArray.includes(a.id));
        this.applicationsAdminOf = appArray;
      },
      saveUser() {
        let appAdminOfIDs = [];
        let orgAdminOfIDs = [];
        let orgUserOfIDs = [];
        this.applicationsAdminOf.forEach((element) => {
          appAdminOfIDs.push(element.id);
        });
        this.organizationsAdminOf.forEach((element) => {
          orgAdminOfIDs.push(element.id);
        });
        this.organizationsUserOf.forEach((element) => {
          orgUserOfIDs.push(element.id);
        });
        this.userFormData.applicationsAdminOf = appAdminOfIDs.join(",");
        this.userFormData.organizationsAdminOf = orgAdminOfIDs.join(",");
        this.userFormData.organizationsUserOf = orgUserOfIDs.join(",");
        console.log(this.userFormData);
        this.manageUserLoading = true;
        this.$store.dispatch("saveUser", this.userFormData).then((result) => {
          if (result === "Success") {
            this.manageUserLoading = false;
            this.manageUserDialog = false;
            this.$swal({
              title: "Success!",
              text: `${this.userFormData.name} was Saved`,
              type: "success",
              confirmButtonText: "Ok",
            });
            this.userFormData = {};
          } else {
            this.$swal({
              title: "Error",
              text: `${this.userFormData.name} Could not be Saved`,
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
    },
  };
  window.createdAtFormatter = function createdTimeFormatter(params) {
    if (params.data.created_at) {
      return moment
        .utc(params.data.created_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
  window.updatedAtFormatter = function createdTimeFormatter(params) {
    if (params.data.updated_at) {
      return moment
        .utc(params.data.updated_at)
        .local()
        .format("MMMM Do YYYY, h:mm:ss a");
    } else {
      return "";
    }
  };
</script>
